<template>
  <div>
    <div class="footer-nav" :class="{ 'extra': (isInWechatMP || isInWechat) }">
      <ul class="clearfix">
        <li v-for="(item, index) in navList" v-bind:key="index" :class="{'current': index === current}" @click="gotoPage(item.link)">
          <icon :name="item.name"></icon>
          <span>{{ item.title }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import PAGES from '@/constants/page'
export default {
  props: {
    current: {
      type: Number,
      default: 3,
    },
    navList: {
      type: Array,
      default: () => [
        {
          name: 'index',
          title: '首页',
          link: PAGES.INDEX
        },
        {
          name: 'cart',
          title: '商城',
          link: '/shop'
        },
        {
          name: 'schedule',
          title: '日程',
          link: PAGES.SCHEDULES
        },
        {
          name: 'discovery',
          title: '发现',
          link: PAGES.DISCOVERY
        },
        {
          name: 'my',
          title: '我的',
          link: PAGES.MY
        }
      ]
    }
  },
  methods: {
    gotoPage (link) {
      if (link === '/shop') {
        location.href = '/shop/#/'
      } else {
        link && this.$router.push({
          name: link
        })
      }
    }
  },
  computed: {
    isInWechatMP: () => {
      return (navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i)) || window.__wxjs_environment === 'miniprogram';
    },
    isInWechat: () => {
      return navigator.userAgent.match(/micromessenger/i);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav.vue